import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Button } from './Button';
import { ArrowRight, ChevronDown } from 'lucide-react';
export function Hero() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    setIsVisible(true);
  }, []);
  const scrollToContent = () => {
    window.scrollTo({
      top: window.innerHeight,
      behavior: 'smooth'
    });
  };
  return <section className="relative min-h-screen flex items-center justify-center overflow-hidden" data-id="element-166">
      {/* Background Image with Parallax Effect */}
      <div className="absolute inset-0 z-0" data-id="element-167">
        <div className="absolute inset-0 bg-gradient-to-br from-charcoal/95 via-charcoal/85 to-charcoal/75 z-10" data-id="element-168" />
        <img src="https://cdn.magicpatterns.com/uploads/tFDLuyek5uaiJaBk7KCJhX/b503129e-f39b-4a87-b053-66ccdd6331b4.jpg" alt="SFRR Foundation community development work in Nigeria" className="w-full h-full object-cover object-center scale-105" loading="eager" width="1920" height="1080" data-id="element-169" />
      </div>

      {/* Decorative Elements */}
      <div className="absolute top-20 right-10 w-72 h-72 bg-primary/20 rounded-full blur-3xl animate-float" aria-hidden="true" data-id="element-170" />
      <div className="absolute bottom-20 left-10 w-96 h-96 bg-secondary/20 rounded-full blur-3xl animate-float" style={{
      animationDelay: '2s'
    }} aria-hidden="true" data-id="element-171" />

      <div className="container mx-auto px-4 relative z-20 pt-24 pb-16" data-id="element-172">
        <div className="max-w-5xl mx-auto text-center" data-id="element-173">
          {/* Badge */}
          <div className={`inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-white/10 backdrop-blur-md border border-white/20 text-white text-sm font-medium mb-8 transition-all duration-700 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`} data-id="element-174">
            <span className="w-2 h-2 rounded-full bg-primary animate-pulse" aria-hidden="true" data-id="element-175" />
            RC 157857 • Non-Profit Organization
          </div>

          {/* Main Heading */}
          <h1 className={`text-5xl md:text-6xl lg:text-7xl xl:text-8xl font-serif font-bold text-white leading-[1.1] mb-6 transition-all duration-700 delay-100 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`} data-id="element-176">
            Touching Lives.
            <br data-id="element-177" />
            <span className="relative inline-block" data-id="element-178">
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary via-secondary to-accent" data-id="element-179">
                Building Futures.
              </span>
              <svg className="absolute -bottom-2 left-0 w-full" height="12" viewBox="0 0 300 12" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" data-id="element-180">
                <path d="M2 10C50 5 100 2 150 2C200 2 250 5 298 10" stroke="url(#gradient)" strokeWidth="3" strokeLinecap="round" data-id="element-181" />
                <defs data-id="element-182">
                  <linearGradient id="gradient" x1="0%" y1="0%" x2="100%" y2="0%" data-id="element-183">
                    <stop offset="0%" stopColor="#0F766E" data-id="element-184" />
                    <stop offset="50%" stopColor="#D97706" data-id="element-185" />
                    <stop offset="100%" stopColor="#F87171" data-id="element-186" />
                  </linearGradient>
                </defs>
              </svg>
            </span>
          </h1>

          {/* Subtitle */}
          <p className={`text-lg md:text-xl lg:text-2xl text-gray-200 mb-12 max-w-3xl mx-auto leading-relaxed font-light transition-all duration-700 delay-200 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`} data-id="element-187">
            The Senator Fatimat Raji Rasaki Foundation is a non-profit,
            non-political organization dedicated to improving lives and
            strengthening communities across Nigeria through sustainable
            development and humanitarian service.
          </p>

          {/* CTA Buttons */}
          <div className={`flex flex-col sm:flex-row gap-4 justify-center items-center transition-all duration-700 delay-300 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`} data-id="element-188">
            <Link to="/donate" data-id="element-189">
              <Button variant="primary" size="lg" className="min-w-[200px] shadow-glow-primary" data-id="element-190">
                Donate to Make an Impact
              </Button>
            </Link>
            <Link to="/programs" data-id="element-191">
              <Button variant="white" size="lg" className="min-w-[200px] group" data-id="element-192">
                Our Programs
                <ArrowRight className="ml-2 w-5 h-5 transition-transform group-hover:translate-x-1" data-id="element-193" />
              </Button>
            </Link>
          </div>

          {/* Stats Preview */}
          <div className={`mt-16 grid grid-cols-2 md:grid-cols-4 gap-6 max-w-4xl mx-auto transition-all duration-700 delay-400 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`} data-id="element-194">
            {[{
            label: 'Focus Areas',
            value: '6'
          }, {
            label: 'Reach',
            value: 'Pan-Nigerian'
          }, {
            label: 'Registered',
            value: 'RC 157857'
          }, {
            label: 'Approach',
            value: 'Non-Political'
          }].map((stat, index) => <div key={index} className="bg-white/10 backdrop-blur-md rounded-2xl p-4 border border-white/20" data-id="element-195">
                <div className="text-2xl md:text-3xl font-serif font-bold text-white mb-1" data-id="element-196">
                  {stat.value}
                </div>
                <div className="text-sm text-gray-300" data-id="element-197">{stat.label}</div>
              </div>)}
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <button onClick={scrollToContent} className="absolute bottom-8 left-1/2 -translate-x-1/2 z-20 flex flex-col items-center gap-2 text-white/70 hover:text-white transition-all duration-300 group animate-bounce" aria-label="Scroll to content" data-id="element-198">
        <span className="text-xs font-medium tracking-widest uppercase" data-id="element-199">
          Explore
        </span>
        <ChevronDown className="w-6 h-6 group-hover:translate-y-1 transition-transform" data-id="element-200" />
      </button>
    </section>;
}